import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-lines-bs',
  templateUrl: './consignment-lines-bs.component.html',
  styleUrls: ['./consignment-lines-bs.component.css']
})
export class ConsignmentLinesBsComponent implements OnInit {
    argType;

    argValue;

    public itemsListPicked: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadPicked() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListPicked = await this.datatask.Post(703, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadPicked();
    }

    ngOnInit() {
        this.init();
    }
}
